import type { TranslateService } from "@core/api/translate.service";
import { translateLangRequiredFn } from "./translate";

// Binding del servicio de traducción a una función que recibe un objeto de error de http
// Y devuelve un nuevo objeto con el título, el mensaje y el código de estatus
export const parseHttpErrorFn = (translateService: TranslateService) => {
  const translate = translateLangRequiredFn(translateService);

  return (err: any, lang: string = ''): { title: string, message: string, status: number } => {
    const title: string = `${ translate('error', 'Error', lang) }`;
    const message: string = err?.error?.message ?? err?.message ?? `${ translate('unknown_error', 'Error desconocido', lang) }`;
    let status: number = 400;
    if (err.status)
      status = err.status;
    return { title, message, status };
  };
}

// Misma función; con parámetro "lang" requerido
export const parseHttpErrorLangRequiredFn = (translateService: TranslateService) => {
  const parseError = parseHttpErrorFn(translateService);

  return (err: any, lang: string) => parseError(err, lang);
}
